import React, { useEffect, useMemo } from "react";
import styled from "styled-components";
import { DEEPLINK_CONFIG } from "../config/appConfig";

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ffffff 0%, #fff8f2 100%);
  padding: 24px;
`;

const Card = styled.div`
  width: 100%;
  max-width: 520px;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 10px 30px rgba(210, 105, 30, 0.12);
  padding: 28px;
  text-align: center;
`;

const Title = styled.h1`
  margin: 0 0 12px 0;
  font-size: 22px;
  color: #d2691e;
`;

const Desc = styled.p`
  margin: 0 0 24px 0;
  color: #6b6b6b;
`;

const Button = styled.a`
  display: inline-block;
  padding: 12px 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, #d2691e 0%, #b85a1a 100%);
  color: #fff;
  font-weight: 600;
  text-decoration: none;
`;

function Invite() {
  const searchParams = useMemo(
    () => new URLSearchParams(window.location.search),
    []
  );
  const userId = searchParams.get("userId") || "";
  const userName = searchParams.get("userName") || "";

  useEffect(() => {
    const timer = setTimeout(() => {
      const iosUrl = DEEPLINK_CONFIG.STORE_URLS.ios(
        DEEPLINK_CONFIG.IOS_APP_NUMERIC_ID
      );
      const androidUrl = DEEPLINK_CONFIG.STORE_URLS.android(
        DEEPLINK_CONFIG.ANDROID_PACKAGE
      );

      const ua = navigator.userAgent || "";
      const isIOS = /iPad|iPhone|iPod/.test(ua);
      const target = isIOS ? iosUrl : androidUrl;
      if (target) {
        window.location.href = target;
      }
    }, DEEPLINK_CONFIG.TIMEOUT_MS);

    // 앱 열기 시도
    const scheme = `${
      DEEPLINK_CONFIG.APP_SCHEME
    }://invite?userId=${encodeURIComponent(
      userId
    )}&userName=${encodeURIComponent(userName)}`;
    window.location.href = scheme;

    return () => clearTimeout(timer);
  }, [userId, userName]);

  return (
    <Container>
      <Card>
        <Title>앱을 여는 중...</Title>
        <Desc>
          친구 초대 링크를 처리하고 있어요. 앱이 자동으로 열리지 않으면 아래
          버튼을 눌러 앱을 설치해 주세요.
        </Desc>
        <Button href="#" onClick={(e) => e.preventDefault()}>
          잠시만 기다려주세요
        </Button>
      </Card>
    </Container>
  );
}

export default Invite;
